"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialIcons = exports.Title = exports.Footer = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  padding: 40px 10px;\n"], ["\n  background: ", ";\n  color: ", ";\n  padding: 40px 10px;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  text-transform: ", ";\n  font-weight: 600;\n"], ["\n  color: ", ";\n  font-size: ", ";\n  text-transform: ", ";\n  font-weight: 600;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  display: inline-block;\n  &:hover {\n    color: ", " !important;\n    /* border-color: ", "; */\n  }\n"], ["\n  color: ", ";\n  font-size: ", ";\n  display: inline-block;\n  &:hover {\n    color: ", " !important;\n    /* border-color: ", "; */\n  }\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globalCss = require("../../../styles/globalCss");

var variable = _interopRequireWildcard(_globalCss);

var _colors = require("../../../styles/colors");

var colors = _interopRequireWildcard(_colors);

var _breakpoints = require("../../../styles/breakpoints");

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Footer = exports.Footer = _styledComponents2.default.footer(_templateObject, function (props) {
  return props.footerBackground || "#36444f";
}, function (props) {
  return props.textColor || colors.whiteColor;
});

var Title = exports.Title = _styledComponents2.default.h4(_templateObject2, function (props) {
  return props.titleColor || colors.whiteColor;
}, function (props) {
  return props.titleFontSize || variable.baseFont;
}, function (props) {
  return props.titleFont || "uppercase";
});

var SocialIcons = exports.SocialIcons = _styledComponents2.default.a(_templateObject3, function (props) {
  return props.iconColor || colors.whiteColor;
}, function (props) {
  return props.size || "25px";
}, function (props) {
  return props.iconHoverColor || {};
}, function (props) {
  return props.hoverBorderColor;
});